import { getAttribute, type ScriptParams } from '../getScriptParams.tsx';
import type { PluginTypeOrderParams } from './PluginTypeParams.ts';

type GetPluginTypeOrderParamsArgs = {
  node: Element;
  projectType: string;
  scriptParams?: Partial<ScriptParams>;
};

export const getPluginTypeOrderParams = ({
  node,
  projectType,
  scriptParams,
}: GetPluginTypeOrderParamsArgs): PluginTypeOrderParams => {
  const appID = getAttribute(node, 'data-appid') || scriptParams?.appID;

  const correlationID =
    getAttribute(node, 'data-correlationID') || scriptParams?.correlationID;

  const paymentLinkID =
    getAttribute(node, 'data-paymentLinkID') || scriptParams?.paymentLinkID;

  const isTemp = !!scriptParams?.isTemp;

  return {
    appID,
    correlationID,
    paymentLinkID,
    projectType,
    isTemp,
  };
};
